import { Routes } from '@angular/router';

export const userContent: Routes = [
  {
    path: 'persoana-fizica',
    loadChildren: () => import('../../components/account/users.module').then(m => m.UsersModule),
    data: {
      breadcrumb: "Persoana fizica"
    }
  },
  {
    path: 'persoana-juridica',
    loadChildren: () => import('../../components/company/company.module').then(m => m.CompanyModule),
    data: {
      breadcrumb: "Persoana juridica"
    }
  },
  {
    path: 'comparator',
    loadChildren: () => import('../../components/comparator/comparator.module').then(m => m.ComparatorModule),
    data: {
      breadcrumb: "Comparator Oferte"
    }
  },
  {
    path: 'schimba-furnizor',
    loadChildren: () => import('../../components/supplier-wizard/supplier-wizard.module').then(m => m.SupplierWizardModule)
  }
];


export const supplierContent: Routes = [
  {
    path: '',
    loadChildren: () => import('../../components/supplier/supplier.module').then(m => m.SupplierModule),
    data: {
      breadcrumb: "Furnizor"
    }
  },
  {
    path: 'schimba-furnizor',
    loadChildren: () => import('../../components/supplier-wizard/supplier-wizard.module').then(m => m.SupplierWizardModule)
  }
];

export const operatorContent: Routes = [
  {
    path: '',
    loadChildren: () => import('../../components/operator/operator.module').then(m => m.OperatorModule),
    data: {
      breadcrumb: "Operator"
    }
  },
  {
    path: 'schimba-furnizor',
    loadChildren: () => import('../../components/supplier-wizard/supplier-wizard.module').then(m => m.SupplierWizardModule)
  }
];

export const anreContent: Routes = [
  {
    path: '',
    loadChildren: () => import('../../components/anre/anre.module').then(m => m.AnreModule),
    data: {
      breadcrumb: "ANRE"
    }
  }
];

export const signatureContent: Routes = [
  {
    path: '',
    loadChildren: () => import('../../components/signature/signature.module').then(m => m.SignatureModule)
  }
];
